export interface AccommodationPricePerNight {
  targetPerNight: number;
  acceptedOveragePercent: number;
  maxAllowedPerNight: number;
}

export class AccommodationPriceCalculator {
  /**
   * Calculate the maximum allowed price per night based on target price and accepted overage percentage
   * @param targetPerNight - The target/budget price per night
   * @param acceptedOveragePercent - The accepted overage percentage (0-100)
   * @returns The maximum allowed price per night
   */
  static calculateMaxAllowedPerNight(
    targetPerNight: number,
    acceptedOveragePercent: number
  ): number {
    if (targetPerNight <= 0) {
      return 0;
    }

    return Math.round(targetPerNight + (targetPerNight * acceptedOveragePercent) / 100);
  }

  /**
   * Calculate all accommodation price per night values
   * @param targetPerNight - The target/budget price per night
   * @param acceptedOveragePercent - The accepted overage percentage (0-100)
   * @returns AccommodationPricePerNight object with all calculated values
   */
  static calculate(
    targetPerNight: number,
    acceptedOveragePercent: number
  ): AccommodationPricePerNight {
    const maxAllowedPerNight = this.calculateMaxAllowedPerNight(
      targetPerNight,
      acceptedOveragePercent
    );

    return {
      targetPerNight,
      acceptedOveragePercent,
      maxAllowedPerNight
    };
  }
}
